<template>
  <div class="md:flex md:justify-center">
    <template v-if="questionListMenu">
      <result-list
        :all-questions="allQuestions"
        :on-resize="onResize"
        :question-list-menu="questionListMenu"
        :examination="examination"
        :type="type"
        :is-clicked-question-list="isClickedQuestionList"
        :all-answer-question-answers="allAnswerQuestionAnswers"
        :question-index="questionIndex"
        @set-index="setIndex"
        @confirmation="onOpenConfirmationModal"
        @on-clicked-question-list-menu="onClickedQuestionListMenu" />
    </template>
    <div class="md:py-4 md:w-4/6">
      <commentary
        :all-questions="allQuestions"
        :on-resize="onResize"
        :question-list-menu="questionListMenu"
        :examination="examination"
        :type="type"
        :choices-order="choicesOrder"
        :question-index="questionIndex"
        @plus-index="plusIndex"
        @minus-index="minusIndex"
        @confirmation="onOpenConfirmationModal"
        @on-clicked-question-list-menu="onClickedQuestionListMenu" />
    </div>
  </div>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import Swal from 'sweetalert2'
import {
  computed, reactive, ref, onMounted,
} from 'vue'
import AppClientLayout from '@/Layouts/AppClientLayout'
import ResultList from './ResultList'
import Commentary from './Commentary'

const props = defineProps({
  allQuestions: {
    type: Array,
    default: () => [],
  },
  examination: {
    type: Object,
    default: () => {},
  },
  type: {
    type: String,
    default: null,
  },
  purchases: {
    type: Array,
    default: () => ([]),
  },
  choicesOrder: {
    type: Array,
    default: () => [],
  },
  userData: {
    type: Object,
    default: () => ({}),
  },
  flash: {
    type: Object,
    default: () => ({}),
  },
  allAnswerQuestionAnswers: {
    type: Object,
    default: () => ({}),
  },
})

const questionIndex = ref(0)

const onFinishedExamination = () => {
  Inertia.get(route('client-examinations'))
  localStorage.clear()
}

const onOpenConfirmationModal = () => {
  Swal.fire({
    icon: 'question',
    title: '解説を終了します。',
    html: 'よろしいですか？',
    showCancelButton: true,
    confirmButtonText: 'はい',
    cancelButtonText: 'いいえ',
  }).then((result) => {
    if (result.isConfirmed) {
      onFinishedExamination()
    }
  })
}

const isButtonClick = ref(false)
const isClickedQuestionList = ref(false)

const onClickedQuestionList = () => {
  isClickedQuestionList.value = true
  isButtonClick.value = false
}

const plusIndex = () => questionIndex.value += 1
const minusIndex = () => questionIndex.value -= 1
const setIndex = (value) => questionIndex.value = value

const onClickedButton = () => {
  isClickedQuestionList.value = false
  isButtonClick.value = true
}

const questionListMenu = ref(false)
const onClickedQuestionListMenu = () => questionListMenu.value = !questionListMenu.value
const onResize = ref(false)
const switchByWidth = () => {
  if (window.matchMedia('(max-width: 770px)').matches) {
    onResize.value = true
    questionListMenu.value = false
  } else {
    onResize.value = false
    questionListMenu.value = true
  }
}
onMounted(() => {
  switchByWidth()
  window.addEventListener('resize', switchByWidth)
})
</script>
